import React from 'react'
import GoBackLink from './GoBackLink'

type Props = { children: string | React.ReactNode, small?: boolean, noMargin?: boolean, showGoBack?: boolean, goBackLink?: string }
const PageHeading: React.FC<Props> = ({ children, small, noMargin, showGoBack = true, goBackLink }) => {
  const className = noMargin ? 'items-center' : 'mb-4'
  return (
    <div className={`flex flex-row-reverse justify-end gap-x-2 lg:flex-row lg:justify-between items-start ${className}`}>
      { small ? <h4 className='font-bold'>{children}</h4> : <h1 className='flex-1'>{children}</h1> }
      {showGoBack && <div className='pt-1'><GoBackLink link={goBackLink} /></div>}
    </div>
  )
}

export default PageHeading
